/**
 * Labels for organization pickers.
 *
 * Organization names are not unique (identity is the Clerk org id), and prod
 * has same-name orgs (e.g. three "Cvent"). A select that shows only the name
 * makes them indistinguishable, so a shared name gets the same 8-character
 * id suffix the org slug uses: "Cvent · 39x3CSZq".
 */
export function orgOptionLabels<T extends { id: string; name: string }>(orgs: T[]): Map<string, string> {
  const counts = new Map<string, number>();
  for (const o of orgs) counts.set(o.name, (counts.get(o.name) ?? 0) + 1);
  return new Map(orgs.map(o => [
    o.id,
    (counts.get(o.name) ?? 0) > 1 ? `${o.name} · ${o.id.replace(/^org_/, '').slice(0, 8)}` : o.name,
  ]));
}
